import React, { useState, useMemo } from "react"
import Input from "aldoo-ra/Input"
import Tooltip from "aldoo-ra/Tooltip"

const VariablePicker = ({
  variables = {},
  onVariableSelect,
  onClose
}) => {
  const [searchTerm, setSearchTerm] = useState('')

  // Convert variables data to options format - handle different data structures
  const variableData = variables.data || []

  let variableOptions = []

  if (Array.isArray(variableData)) {
    // Handle array format: [{key: "TITLE", value: "13"}]
    variableOptions = variableData.map(item => ({
      value: item?.key || item,
      name: item?.key || item,
      label: item?.key || item,
      content: item?.value || '' // Store the actual content for tooltip
    }))
  } else if (typeof variableData === 'object' && variableData !== null) {
    // Handle object format: {TITLE: "Thank you!", PRE_HEADER: "Aqua Mail -"}
    variableOptions = Object.keys(variableData).map(key => ({
      value: key,
      name: key,
      label: key,
      content: variableData[key] || '' // Store the actual content for tooltip
    }))
  }

  // Filter options based on search term
  const filteredOptions = useMemo(() => {
    if (!searchTerm) return variableOptions
    return variableOptions.filter(option =>
      option.label.toLowerCase().includes(searchTerm.toLowerCase())
    )
  }, [variableOptions, searchTerm])

  // Handle variable selection
  const handleVariableClick = (option) => {
    onVariableSelect(`{{${option.value}}}`)
    onClose()
  }

  return (
    <div
      className="bg-admin_paper border border-admin_bordered rounded-lg shadow-lg p-4 min-w-[300px] max-w-[400px]"
      data-variable-picker="true"
    >
      <div className="mb-3">
        {/* Search input */}
        <Input
          variant="admin"
          type="text"
          placeholder="Search variables..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full mb-3"
          style={{ userSelect: 'text' }}
          onMouseDown={(e) => e.stopPropagation()}
        />

        {/* Variables list */}
        <div className="max-h-48 overflow-y-auto border border-admin_bordered rounded bg-admin_paper">
          {filteredOptions.length > 0 ? (
            <div className="divide-y divide-admin_bordered">
              {filteredOptions.map((option, index) => (
                <div key={index} className="w-full">
                  <Tooltip
                    content={option.content}
                    variant="dark"
                    placement="right"
                    display="block"
                  >
                    <button
                      onClick={() => handleVariableClick(option)}
                      className="flex w-full min-w-0 text-left px-4 py-3 text-sm font-medium hover:bg-admin_canvas text-admin_text transition-colors focus:outline-none focus:bg-admin_canvas active:bg-admin_primary active:text-white cursor-pointer"
                    >
                      <span className="flex-1">{option.label}</span>
                    </button>
                  </Tooltip>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center text-admin_text_secondary py-8">
              {searchTerm ? `No variables found matching "${searchTerm}"` : 'No variables available'}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default VariablePicker